const ToastStyle = {
    position: "fixed",
    bottom: 32,
    right: 8,
    borderRadius: "25",
    padding: "13px 8px 8px 13px",
    zIndex: 1500
};

export default ToastStyle;